import Vue from 'vue'
export default {
    install(Vue) {
        //统一的页面显示记录条数(特殊情况可以在自己的模块进行覆盖)
        Vue.prototype.pageSizeList=[10,15,30,50,100,500];
        //统一的分页显示
        Vue.prototype.pageLayout="total, sizes, prev, pager, next, jumper"
    }
}
